export class Company {
    id: number;
    name: string;
    user_id: number;

    constructor(id: number, name: string, user_id: number) {
        this.id = id;
        this.name = name;
        this.user_id = user_id
    }

    clone(): Company {
        return new Company (
            this.id,
            this.name,
            this.user_id
        )
    }

    toPrimitive() {
        return {
            id: this.id,
            name: this.name,
            user_id: this.user_id
        }
    }
}

export interface SelectCompanyForEnvoicePopup {
    show(): Promise<any | null>
    close([Company])
}